import { core } from '@tock/coretypes';
import clsx from 'clsx';

import { ConsumerPurchaseSummaryFragment } from 'generated/graphql';
import ReservationPreviewCard from 'components/profile/ReservationPreviewCard';

interface Props {
  emptyState?: JSX.Element;
  /**
   * Specify the error state *only* as an override if there was an error. Leave it
   * undefined if there was no error
   */
  errorState?: JSX.Element;
  patron: core.IPatron;
  purchaseHistory: ConsumerPurchaseSummaryFragment[];
  // Whether to display Reservation actions. Valid only on Reservations in the future.
  showManageReservation: boolean;
  isSelected?: boolean;
}

const ReservationHistorySection = ({
  patron,
  emptyState,
  errorState,
  purchaseHistory,
  showManageReservation,
  isSelected,
}: Props) => {
  return (
    <div className={clsx('ReservationHistory', { 'is-hidden': !isSelected })}>
      {errorState ||
        (purchaseHistory?.length > 0
          ? purchaseHistory.map((transaction, index) => (
              <ReservationPreviewCard
                key={index}
                patron={patron}
                reservation={transaction}
                showManageReservation={showManageReservation}
              />
            ))
          : emptyState)}
    </div>
  );
};

export default ReservationHistorySection;
